import { render, staticRenderFns } from "./ProductsFilters.vue?vue&type=template&id=e4151f6e"
import script from "./ProductsFilters.vue?vue&type=script&lang=js"
export * from "./ProductsFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports